import { Instance } from 'mobx-state-tree';
import { DateTime } from 'luxon';
import { OrganizationBillingDetailDtoModelBase } from './OrganizationBillingDetailDtoModel.base';

/* The TypeScript type of an instance of OrganizationBillingDetailDtoModel */
export interface OrganizationBillingDetailDtoModelType extends Instance<typeof OrganizationBillingDetailDtoModel.Type> {}

/* A graphql query fragment builders for OrganizationBillingDetailDtoModel */
export { selectFromOrganizationBillingDetailDto, organizationBillingDetailDtoModelPrimitives, OrganizationBillingDetailDtoModelSelector } from './OrganizationBillingDetailDtoModel.base';

/**
 * OrganizationBillingDetailDtoModel
 */
export const OrganizationBillingDetailDtoModel = OrganizationBillingDetailDtoModelBase
  .views(self => ({
    get start() {
      return self.currentPeriodStart ? DateTime.fromISO(self.currentPeriodStart).toFormat('LLL dd, yyyy') : undefined;
    },
    get end() {
      return self.currentPeriodEnd ? DateTime.fromISO(self.currentPeriodEnd).toFormat('LLL dd, yyyy') : undefined;
    },
    get usage() {
      return self?.currentPeriodUsage || 0;
    },
  }))
  .views((self) => ({
    get isFreePlan() {
      return self?.name === 'free';
    },
    get isGrowthTrialPlan() {
      return self?.name === 'growth_trial';
    },
    get isGrowthPlan() {
      return self?.name === 'growth';
    },
    get remainingUsage(): number | undefined {
      return self.usageLimit ? Math.max(0, self.usageLimit - self.usage) : undefined;
    },
  }))
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
